export const copiedToClipboardSelector = state => state.common.isCopiedToClipboard;